var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_6929",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 1.3335C9.00004 0.781211 8.55233 0.333496 8.00004 0.333496C7.44776 0.333496 7.00004 0.781211 7.00004 1.3335V7.00016H1.33337C0.78109 7.00016 0.333374 7.44788 0.333374 8.00016C0.333374 8.55245 0.78109 9.00016 1.33337 9.00016H7.00004V14.6668C7.00004 15.2191 7.44776 15.6668 8.00004 15.6668C8.55233 15.6668 9.00004 15.2191 9.00004 14.6668V9.00016H14.6667C15.219 9.00016 15.6667 8.55245 15.6667 8.00016C15.6667 7.44788 15.219 7.00016 14.6667 7.00016H9.00004V1.3335Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_6929)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#1EB65B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAdd);
export default __webpack_public_path__ + "static/media/chat_add.d9ddb551f9a6fa5a7c0a720c3ad14e55.svg";
export { ForwardRef as ReactComponent };